import React from 'react'

const LoadingIndicator = () => {
  return (
    <div>
      
    </div>
  )
}

export default LoadingIndicator
